// extracted by mini-css-extract-plugin
export var customIcon = "HelpLink-module__customIcon___Q11ft";
export var iconText = "HelpLink-module__iconText___NLRjr";
export var link = "HelpLink-module__link___a5Ghs";
export var linkContainer = "HelpLink-module__linkContainer___gGaHd";